module.exports = __webpack_public_path__ + "static/35-b6c7efbae5689f93c8cad8751b537fa5.png";